




import { Component, Vue } from 'vue-property-decorator';
import { Mutation } from 'vuex-class';
import OrganizationList from '../components/OrganizationList.vue';

@Component({
  components: { OrganizationList },
})
export default class Organization extends Vue {
  @Mutation private showOrg!: (id: string) => void;
  private created() {
    this.showOrg('@');
  }
}
